import { Link } from "react-router-dom";
import { Heart, MapPin } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";

const STATUS_STYLE = {
  available: "bg-eon-gold text-white",
  reserved: "bg-yellow-900/40 text-yellow-300 border border-yellow-700/40",
  sold: "bg-red-900/30 text-red-300 border border-red-800/40",
  coming_soon: "bg-eon-elevated text-eon-text/70 border border-eon-border",
};

export function DogCard({ dog, index = 0 }) {
  const { user } = useAuth();
  const fav = async (e) => {
    e.preventDefault();
    if (!user) { toast.error("Sign in to save favorites"); return; }
    try {
      const { data } = await api.post("/favorites", { item_type: "dog", item_id: dog.id });
      toast.success(data.favorited ? "Saved to favorites" : "Removed from favorites");
    } catch { toast.error("Could not update favorites"); }
  };
  return (
    <Link to={`/dogs/${dog.id}`} data-testid={`dog-card-${dog.id}`}
      className="eon-card group flex flex-col animate-fade-up" style={{ animationDelay: `${index * 40}ms` }}>
      <div className="relative aspect-[4/5] overflow-hidden">
        <img src={dog.image} alt={dog.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-eon-bg via-transparent to-transparent" />
        <span className={`absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 ${STATUS_STYLE[dog.status] || STATUS_STYLE.available}`}>
          {(dog.status || "available").replace("_", " ")}
        </span>
        {dog.is_eon_owned
          ? <span className="absolute top-3 right-3 eon-label bg-eon-gold text-white px-2 py-1">E.O.N Owned</span>
          : <span className="absolute top-3 right-3 eon-label bg-black/60 px-2 py-1">Breeder</span>}
        <button onClick={fav} data-testid={`fav-dog-${dog.id}`}
          className="absolute bottom-3 right-3 w-9 h-9 flex items-center justify-center bg-black/50 hover:bg-eon-gold hover:text-black text-white transition-colors">
          <Heart size={16} />
        </button>
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-xl font-bold text-eon-text">{dog.name}</h3>
          <span className="font-mono text-eon-gold text-sm font-medium whitespace-nowrap">${dog.price?.toLocaleString()}</span>
        </div>
        <div className="eon-label mt-1">{dog.breed}</div>
        <div className="mt-auto pt-4 flex items-center gap-3 text-xs text-eon-muted">
          <span className="capitalize">{dog.sex}</span><span>·</span><span>{dog.age}</span><span>·</span>
          <span className="flex items-center gap-1"><MapPin size={12} /> {dog.city}, {dog.state}</span>
        </div>
      </div>
    </Link>
  );
}
